export default __webpack_public_path__ + "resources/icons/d431-0bf7.png";